import { sellTicketStatusInversed } from '@teinor/erp/types/company/order/sell/sellTicket'
import { useCallback } from 'react'
import { CustomSelectWithSearchBar } from '../../../../../../../../../forms/CustomSelect'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../../../../../forms/TwinForm/types'
import BasePaymentMethodsTPV from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/components/BasePaymentMethodsTPV'
import ChangeMoneyComponentTPV from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/components/BasePaymentMethodsTPV/PaymentMethodsTypesBoxTPV/ChangeMoneyComponentTPV'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import useIsLoading from '../../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { changeErrorMessage } from '../../../../../../../../../utils/reducers/reduxDispatch'
import { HookBaseFuntionModalPaymentMethodTPVProps, HookComponentFuntionModalPaymentMethodTPVProps } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/components/BasePaymentMethodsTPV/types'
import { twinFetchPostJSON } from '../../../../../../../../../utils/globals/data'
import VoucherComponentTPV from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/components/BasePaymentMethodsTPV/PaymentMethodsTypesBoxTPV/VoucherComponentTPV'
import { ModalPaymentMethodTPVProps } from '..'
import { PaymentRelatedTypesKeys } from '@teinor/erp/types/company/config/paymentType'


const ModalPaymentMethodSellTicket: React.FC<ModalPaymentMethodTPVProps> = ({ url, completeData, setOpenModal, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    return (
        <BasePaymentMethodsTPV url={url} completeData={completeData} setOpenModal={setOpenModal} tableData={completeData.tableData as any} hookComponentsFuntion={usePaymentMethodTypesComponentLogic} hookBaseFuntion={useModalPaymentMethodSellTicketLogic} translations={{ textButton: t('confirmCharge', 'Confirmar cobro'), textTotal: t('totalTicket', 'Total ticket') }} onSubmit={onSubmit} allRowData={allRowData} />
    )
}

const useModalPaymentMethodSellTicketLogic = ({ completeData, setOpenModal, onSubmit, checkAllOk, myTotalPayments, allRowData }: HookBaseFuntionModalPaymentMethodTPVProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const { t } = useTwinTranslation()
    const noWarehouse = t('noWarehouse', 'Este centro de trabajo no tiene almacén')
    const noValidVoucher = t('noValidVoucher', 'Vale no válido')
    const noMatchQuantity = t('notMatchQuantity', 'Las cantidades no coinciden')
    const noPaymentRegistered = t('noPaymentRegistered', 'No se ha registrado un pago')
    
    const handleBeforeSubmit: BeforeSubmitHandler = useCallback((vals, form) => {
        startLoading?.()
        const itsOk = checkAllOk(vals, form)
        if (!itsOk) {
            return false
        }
        vals.status = vals.partialCharge ? sellTicketStatusInversed['partialCharged'] : sellTicketStatusInversed['accepted']
        vals.id = completeData?.header?.id
        vals.CashRegisterId = completeData?.cashRegister?.id
        const isAlreadyReserved = parseInt(String(completeData?.header?.status)) === sellTicketStatusInversed['partialCharged']
        vals.skipCheckOperateStock = isAlreadyReserved ? true : allRowData?.skipCheckOperateStock
        return true
    }, [checkAllOk, completeData?.header?.id, completeData?.cashRegister?.id, allRowData?.skipCheckOperateStock, completeData?.header?.status, startLoading])
    
    const handleOnSubmit: OnSubmit = useCallback(async (res, values) => {
        const result = await res.json()
        if (result) {
            const Order = await twinFetchPostJSON('/api/app/order/tpv/sellTicket/getSellTicketComplete', {id: completeData?.header?.id})
            onSubmit?.()
            if (Order) {
                setOpenModal({ type: 'delete', allRowData: { ...values, CurrencyId: completeData?.header?.CurrencyId, myTotalPayments, headerData: Order.header, OrderId: completeData?.header?.id, WorkingCenterId: completeData?.cashRegister?.WorkingCenterId }})
            }
        }
        endLoading?.()
    }, [endLoading, setOpenModal, onSubmit, myTotalPayments, completeData])

    const handleErrors: OnSubmit = useCallback(async(res) => {
        const result = await res.json()
        if (result) {
            if (result?.errors?.[0]?.msg === 'NoWarehouse') {
                changeErrorMessage(noWarehouse)
            } else if (result?.errors?.[0]?.msg === 'noValidVoucher') {
                changeErrorMessage(noValidVoucher)
            } else if (result?.errors?.[0]?.msg === 'noMatchQuantity') {
                changeErrorMessage(noMatchQuantity)
            } else if (result?.errors?.[0]?.msg === 'noPaymentRegistered') {
                changeErrorMessage(noPaymentRegistered)
            }
        }
        endLoading?.()
    }, [noWarehouse, noValidVoucher, noMatchQuantity, endLoading, noPaymentRegistered])

    return { handleOnSubmit, handleBeforeSubmit, loading, handleErrors }
}

const usePaymentMethodTypesComponentLogic = ({ element, myCurrencyId, setMyTotalPayments, myTotalPayments, dictPaymentBanks, handleChangeField, rowIndex, dictVouchers}: HookComponentFuntionModalPaymentMethodTPVProps) => {
    const { t } = useTwinTranslation()
    const dictComponentLabels: Record<PaymentRelatedTypesKeys, TwinDictionary> = {
        0: {
            component: ChangeMoneyComponentTPV,
            label: t('moneyGivenByCustomer', 'Entregado por cliente'),
            extraProps: { myCurrencyId, quantity: element.quantity, className: 'justify-end flex w-150', setMyTotalPayments, myTotalPayments: myTotalPayments?.myTotalPayments, PaymentTypeId: element.PaymentTypeId },
        },
        1: {
            component: CustomSelectWithSearchBar,
            label: t('targetAccount', 'Cuenta de destino'),
            extraProps: { items: dictPaymentBanks?.customerBanks?.items || {}, className: 'flex flex-auto custom_select_hide_label h-28 overflow-visible', fieldName: 'fullname', value: element?.new_extra_payment_data?.id || element?.new_extra_payment_data?.value || element?.payment_data || dictPaymentBanks?.customerBanks?.defaultId, onChange: (value: any) => handleChangeField(rowIndex, 'payment_data', value) }
        },
        2: {
            component: CustomSelectWithSearchBar,
            label: t('targetAccount', 'Cuenta de destino'),
            extraProps: { items: dictPaymentBanks?.workingCenterBanks?.items || {}, className: 'flex flex-auto  custom_select_hide_label h-28  overflow-visible', fieldName: 'fullname', value: element?.new_extra_payment_data?.id || element?.new_extra_payment_data?.value || element?.payment_data || dictPaymentBanks?.workingCenterBanks?.defaultId, onChange: (value: any) => handleChangeField(rowIndex, 'payment_data', value) }
        },
        3: { label: '', extraProps: {} },
        4: { label: '', extraProps: {} },
        5: {
            headerComponent: VoucherComponentTPV,
            component: VoucherComponentTPV,
            label: t('customerVoucer', 'Cupones del cliente'),
            headerConditionRender: (value: number) => value === 0,
            extraProps: {
                items: dictVouchers,
                setMyTotalPayments,
                myTotalPayments,
                PaymentTypeId: element.PaymentTypeId
            }
        },
        6: {
            component: CustomSelectWithSearchBar,
            label: t('targetDataphone', 'Datáfono de destino'),
            extraProps: { items: dictPaymentBanks?.workingCenterShift4Devices?.items || {}, className: 'flex flex-auto  custom_select_hide_label h-28  overflow-visible', value: element?.new_extra_payment_data?.id || element?.new_extra_payment_data?.value || element?.payment_data || dictPaymentBanks?.workingCenterShift4Devices?.defaultId, onChange: (value: any) => handleChangeField(rowIndex, 'payment_data', value) }
        },
        7: { label: '', extraProps: {} },
    }

    return { dictComponentLabels }
}

export default ModalPaymentMethodSellTicket